/**
 * @file
 * Behaviors for the Site Header.
 */
/* eslint-disable max-len */

(function(Drupal, once) {

  /**
   *  Adds click and keyboard selection event add the same time.
   *
   * @param {HTMLElement} el Element to add events to
   * @param {Function} handler Function to be called when the event occurs
   * @return {void}
   */
  const addOnSelectListener = (el, handler) => {
    el.addEventListener('click', handler);
    el.addEventListener('keyup', (e) => {
      if (event.keyCode === 13) {
        handler(e);
      }
    });
  };

  /**
   * Setup and attach the Site Header behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.siteHeader = {
    attach: function (context) {
      once('siteHeader', '.site-header', context).forEach(function () {
        const searchBtn = document.querySelector(
          '.search-btn'
        );
        const homeSearchMenu = document.querySelector(
          '.home-search'
        );
        const linkListCTAs = document.querySelectorAll(
          '.links-list-cta'
        );
        const mobileHeaderMenuBtn = document.querySelector('#mobile-header-menu-btn');
        const mobileHeaderMenu = document.querySelector('#mobile-header-menu');
        const messageBtn = document.querySelector('.messages-btn');
        const messageContainer = document.querySelector('#messages-container');
        const closeBtn = document.querySelector('.messages-container-close-button');

        if (messageBtn) {
          addOnSelectListener(closeBtn, () => {
            if (messageContainer.classList.contains('hidden')) {
              messageContainer.classList.remove('hidden');
            }
            else {
              messageContainer.classList.add('hidden');
            }
          });

          addOnSelectListener(messageBtn, () => {
            if (messageContainer.classList.contains('hidden')) {
              messageContainer.classList.remove('hidden');
            }
            else {
              messageContainer.classList.add('hidden');
            }
          });
        }

        if (searchBtn && homeSearchMenu) {
          addOnSelectListener(searchBtn, () => {
            const action = homeSearchMenu.classList.contains('hidden') ? 'remove' : 'add';
            homeSearchMenu.classList[action]('hidden');
            const submenus = Array.from(document.querySelectorAll('.submenu') || []);
            submenus.forEach(e => e.style.display = 'none');
          });
        }

        if (linkListCTAs) {
          const ctas = Array.from(linkListCTAs).filter(item => item.role === 'button');
          for (let cta of ctas) {
            cta.addEventListener('click', (e) => {
              e.preventDefault();

              if (homeSearchMenu) {
                homeSearchMenu.classList.add('hidden');
              }

              const id =  e.target.id;
              const submenu = document.querySelector(`#submenu-${id}`);
              const otherSubmenus = Array.from(document.querySelectorAll('.submenu') || []).filter(e => e !== submenu);
              otherSubmenus.forEach(e => e.style.display = 'none');

              if (submenu) {
                submenu.style.display = submenu.checkVisibility() ? 'none' : 'flex';
              }
            });
          }
        }

        if (mobileHeaderMenuBtn && mobileHeaderMenu) {
          addOnSelectListener(mobileHeaderMenuBtn, () => {
            mobileHeaderMenu.style.display = mobileHeaderMenu.checkVisibility() ? 'none' : 'block';
            const submenus = Array.from(document.querySelectorAll('.submenu') || []);
            submenus.forEach(e => e.style.display = 'none');
          });
        }


        const userMenuSelector = '.menu.user-menu';
        const profileButtonSelector = '.profile-btn';
        once('user-menu-container', `.profile-options-container:has(${userMenuSelector}):has(${profileButtonSelector})`, context).forEach((container) => {
          const menu = container.querySelector(userMenuSelector);
          const profileButton = container.querySelector(profileButtonSelector);
          addOnSelectListener(profileButton, () => {
            menu.style.display = menu.checkVisibility() ? 'none' : 'flex';
          });
        });
      });
    },

  };
})(Drupal, once);
